import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-455b232e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "-mcenter" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("下载")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "-image",
      style: _normalizeStyle('background-image: url('+$setup.view.checkImage+');')
    }, null, 4),
    _withDirectives(_createVNode(_component_el_button, {
      type: "primary",
      class: "-mt30 -w100",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.download(true)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 512), [
      [_vShow, $setup.view.checkImage]
    ])
  ]))
}